import { ProgramArticlePictureETTValue } from "../../models/program-article-translation-value";
import {
  PROGRAM_ARTICLES_ACTIONS,
  ProgramArticlesStateInterface,
} from "../actions/program-articles.actions";

const initialState: ProgramArticlesStateInterface = {
  programArticles: [],
  currentProgramArticle: null,
};

const formats = [
  "Original",
  "16:9",
  "4:3",
  "3:4",
  "7:15",
  "10:3",
  "1:1",
  "2:3",
  "3:1",
  "140:303",
  "485:173",
];

export function programArticlesReducer(
  state: ProgramArticlesStateInterface = initialState,
  action
) {
  switch (action.type) {
    case PROGRAM_ARTICLES_ACTIONS.SET_PROGRAM_ARTICLES:
      state.programArticles = action.payload;
      return Object.assign({}, state);

    case PROGRAM_ARTICLES_ACTIONS.SET_CURRENT_PROGRAM_ARTICLE:
      state.currentProgramArticle = action.payload;
      return Object.assign({}, state);

    case PROGRAM_ARTICLES_ACTIONS.UPDATE_PROGRAM_ARTICLE:
      state.programArticles.forEach((program, index) => {
        if (program.id === action.payload.id) {
          state.programArticles[index] = action.payload;
        }
      });
      return Object.assign({}, state);

    case PROGRAM_ARTICLES_ACTIONS.UPDATE_PROGRAM_ARTICLES:
      state.programArticles.forEach((program, index) => {
        const find = action.payload.find(
          (p) =>
            program.valEmiId === p.valEmiId &&
            program.channel.id === p.channel.id
        );
        if (find) {
          state.programArticles[index] = find;
        }
      });
      return Object.assign({}, state);

    case PROGRAM_ARTICLES_ACTIONS.UPDATE_PROGRAM_ARTICLE_PICTURE:
      let destinationType = action.payload.type;
      let language = state.currentProgramArticle.destinations
        .find((d) => {
          return d.id === destinationType;
        })
        .value.pictures.find(
          (p) => p.pictureFormatName === "Original"
        ).language;
      let channel = state.currentProgramArticle.destinations
        .find((d) => {
          return d.id === destinationType;
        })
        .value.pictures.find((p) => p.pictureFormatName === "Original").channel;

      formats.forEach((format) => {
        // if not found, create it
        if (
          action.payload.pictures.find((p) => p.pictureFormatName === format) &&
          (action.payload.pictures.find((p) => p.pictureFormatName === format)
            .url ||
            action.payload.pictures.find((p) => p.pictureFormatName === format)
              .blob)
        ) {
          if (
            state.currentProgramArticle.destinations
              .find((d) => {
                return d.id === destinationType;
              })
              .value.pictures.find((p) => p.pictureFormatName === format)
          ) {
            state.currentProgramArticle.destinations
              .find((d) => {
                return d.id === destinationType;
              })
              .value.pictures.find(
                (p) => p.pictureFormatName === format
              ).pictureURL = null;

            state.currentProgramArticle.destinations
              .find((d) => {
                return d.id === destinationType;
              })
              .value.pictures.find((p) => p.pictureFormatName === format).blob =
              action.payload.pictures.find(
                (p) => p.pictureFormatName === format
              ).blob;

            state.currentProgramArticle.destinations
              .find((d) => {
                return d.id === destinationType;
              })
              .value.pictures.find(
                (p) => p.pictureFormatName === format
              ).isLocked = true;

            state.currentProgramArticle.destinations
              .find((d) => {
                return d.id === destinationType;
              })
              .value.pictures.find(
                (p) => p.pictureFormatName === format
              ).modified = true;

            state.currentProgramArticle.destinations
              .find((d) => d.id === destinationType)
              .value.pictures.forEach((p) => (p.isLocked = true));

            if (
              destinationType === "Digital" &&
              format !== "4:3" &&
              format !== "3:4" &&
              format !== "7:15" &&
              format !== "10:3" &&
              format !== "1:1" &&
              format !== "2:3" &&
              format !== "3:1" &&
              format !== "140:303" &&
              format !== "485:173" &&
              state.currentProgramArticle.destinations.find(
                (d) => d.id === "Popup Next"
              ) &&
              state.currentProgramArticle.destinations
                .find((d) => d.id === "Popup Next")
                .value.pictures.find((p) => p.pictureFormatCode === format) &&
              !state.currentProgramArticle.destinations
                .find((d) => d.id === "Popup Next")
                .value.pictures.find((p) => p.pictureFormatCode === format)
                .isLocked
            ) {
              state.currentProgramArticle.destinations
                .find((d) => d.id === "Popup Next")
                .value.pictures.find(
                  (p) => p.pictureFormatName === format
                ).pictureURL = null;

              state.currentProgramArticle.destinations
                .find((d) => d.id === "Popup Next")
                .value.pictures.find(
                  (p) => p.pictureFormatName === format
                ).blob = action.payload.pictures.find(
                (p) => p.pictureFormatName === format
              ).blob;

              state.currentProgramArticle.destinations
                .find((d) => d.id === "Popup Next")
                .value.pictures.find(
                  (p) => p.pictureFormatName === format
                ).isLocked = false;

              state.currentProgramArticle.destinations
                .find((d) => d.id === "Popup Next")
                .value.pictures.find(
                  (p) => p.pictureFormatName === format
                ).modified = true;
            }
          } else {
            let picture = new ProgramArticlePictureETTValue({
              pictureURL: null,
              blob: action.payload.pictures.find(
                (p) => p.pictureFormatName === format
              ).blob,
              isLocked: true,
              modified: true,
              language: language,
              channel: channel,
              pictureFormatName: format,
              pictureFormatCode: format,
            });

            state.currentProgramArticle.destinations
              .find((d) => {
                return d.id === destinationType;
              })
              .value.pictures.push(picture);

            if (
              destinationType === "Digital" &&
              format !== "4:3" &&
              format !== "3:4" &&
              format !== "7:15" &&
              format !== "10:3" &&
              format !== "1:1" &&
              format !== "2:3" &&
              format !== "3:1" &&
              format !== "140:303" &&
              format !== "485:173" &&
              state.currentProgramArticle.destinations.find(
                (d) => d.id === "Popup Next"
              ) &&
              !state.currentProgramArticle.destinations
                .find((d) => d.id === "Popup Next")
                .value.pictures.find((p) => p.pictureFormatCode === format)
            ) {
              state.currentProgramArticle.destinations
                .find((d) => d.id === "Popup Next")
                .value.pictures.push(picture);
            }
          }
          state.currentProgramArticle.destinations.find((d) => {
            return d.id === destinationType;
          }).modified = true;

          state.currentProgramArticle.pictureModified = true;
        }
      });
      return Object.assign({}, state);

    case PROGRAM_ARTICLES_ACTIONS.SET_MULTILINGUAL_TRANSLATIONS:
      const updatedLanguage = [];
      state.currentProgramArticle.destinations
        .filter((destination) => {
          return destination.id === action.payload.destination;
        })
        .map((destination) => {
          destination.modified = true;
          // update program field
          const updatedTranslation = action.payload.translations.find((t) =>
            destination.value.translations.find(
              (tr) => tr.name == t.fieldName && t.language.id === tr.language.id
            )
          );
          if (updatedTranslation) {
            updatedLanguage.push(updatedTranslation.language.id);
            destination.value.translations.find(
              (t) =>
                t.language.id === updatedTranslation.language.id &&
                t.name == updatedTranslation.fieldName
            ).content = updatedTranslation.content;

            destination.value.translations.find(
              (t) =>
                t.language.id === updatedTranslation.language.id &&
                t.name == updatedTranslation.fieldName
            ).isLocked = updatedTranslation.isLocked;
          }
        });
      // add program field from others languages
      action.payload.translations.forEach((newTranslation) => {
        const updatedTranslation = state.currentProgramArticle.destinations
          .find((destination) => destination.id === action.payload.destination)
          .value.translations.find(
            (t) =>
              t.name === newTranslation.fieldName &&
              t.language.id === newTranslation.language.id
          );
        if (!updatedTranslation) {
          state.currentProgramArticle.destinations
            .find(
              (destination) => destination.id === action.payload.destination
            )
            .value.translations.push(newTranslation);
        }
      });
      return Object.assign({}, state);

    case PROGRAM_ARTICLES_ACTIONS.SET_MULTILINGUAL_PICTURES:
      let updatedLanguages = [];
      state.currentProgramArticle.destinations
        .filter((destination) => {
          return destination.id === action.payload.destination;
        })
        .map((destination) => {
          destination.modified = true;

          action.payload.pictures.forEach((picture) => {
            const updatedPicture = state.currentProgramArticle.destinations
              .find(
                (destination) => destination.id === action.payload.destination
              )
              .value.pictures.find(
                (p) =>
                  p.language.id === picture.language.id &&
                  p.pictureFormatCode === picture.pictureFormatCode
              );
            if (updatedPicture) {
              updatedPicture.modified = true;
              updatedLanguages.push(updatedPicture.language.id);
              destination.value.pictures.find(
                (p) =>
                  p.language.id === updatedPicture.language.id &&
                  p.pictureFormatCode === updatedPicture.pictureFormatCode
              ).pictureURL = updatedPicture.pictureURL;

              destination.value.pictures.find(
                (p) =>
                  p.language.id === updatedPicture.language.id &&
                  p.pictureFormatCode === updatedPicture.pictureFormatCode
              ).blob = updatedPicture.blob;

              destination.value.pictures.find(
                (p) =>
                  p.language.id === updatedPicture.language.id &&
                  p.pictureFormatCode === updatedPicture.pictureFormatCode
              ).pictureId = updatedPicture.pictureId;

              destination.value.pictures.find(
                (p) =>
                  p.language.id === updatedPicture.language.id &&
                  p.pictureFormatCode === updatedPicture.pictureFormatCode
              ).isLocked = updatedPicture.isLocked;
            }
          });
        });
      // add program picture from others languages
      action.payload.pictures.forEach((newPicture) => {
        const updatedPicture = state.currentProgramArticle.destinations
          .find((destination) => destination.id === action.payload.destination)
          .value.pictures.find(
            (p) =>
              p.language.id === newPicture.language.id &&
              p.pictureFormatCode === newPicture.pictureFormatCode
          );
        if (!updatedPicture) {
          newPicture.modified = true;
          state.currentProgramArticle.destinations
            .find(
              (destination) => destination.id === action.payload.destination
            )
            .value.pictures.push(newPicture);
        }
      });
      state.currentProgramArticle.pictureModified = true;

      return Object.assign({}, state);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/program-articles.reducer.ts